import _bidiFactory from "bidi-js";
const bidiFactory = _bidiFactory;

/**
 * Reorders mixed-direction caption text using the Unicode bidirectional algorithm.
 *
 * For each line, treats the paragraph as RTL, asks bidi-js which character ranges
 * must be mirrored for correct visual order, and reverses those runs in place.
 * Use this when embedded Latin digits, punctuation, or LTR words appear in the
 * wrong order after legacy RTL decode or before display-oriented processing.
 *
 * @param {string} text - Plain-text caption (may contain multiple newline-separated lines).
 * @returns {string} Text with bidi reorder segments applied per line.
 */
export default (function fixRtlText(text) {
  // console.log("-------------");
  // console.log("fixRtlText", text);
  const bidi = bidiFactory();
  let textLines = text.split("\n");
  textLines.forEach((textLine, index, lines) => {
    let embeddingLevels = bidi.getEmbeddingLevels(textLine,
    //the input string containing mixed-direction text
    "rtl");

    // Only reorder lines that contain an embedded left-to-right run (Latin
    // letters, digits, etc.), which resolve to an even bidi level under an
    // RTL paragraph. A pure RTL line is already in logical order, so a full
    // reversal here would drag trailing punctuation and paired quotes (which
    // are direction-neutral) to the opposite edge of the line.
    let hasEmbeddedLtr = embeddingLevels.levels.some(level => level % 2 === 0);
    if (!hasEmbeddedLtr) {
      lines[index] = textLine;
      return;
    }
    let flips = bidi.getReorderSegments(textLine,
    //the full input string
    embeddingLevels //the full result object from getEmbeddingLevels
    );

    // Process all reversal sequences, in order:
    flips.forEach(range => {
      const [start, end] = range;
      textLine = reversePartsInPlace(textLine, start, end);
    });
    lines[index] = textLine;
  });
  return textLines.join("\n");
});
function reversePartsInPlace(str, start, end) {
  if (start < 0 || end >= str.length || start >= end) {
    throw new Error("Invalid start or end indices");
  }
  let charArray = str.split(""); // Convert the string to an array of characters

  while (start < end) {
    // Swap characters at start and end indices
    const temp = charArray[start];
    charArray[start] = charArray[end];
    charArray[end] = temp;
    start++;
    end--;
  }
  return charArray.join(""); // Convert the array back to a string
}